// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19itglyw{border:none}\n._2rko1sit{border-radius:var(--ds-border-radius,3px)}\n._1bsb1osq{width:100%}\n._1e0c1ule{display:block}\n._1e0cglyw{display:none}\n._4t3i1osq{height:100%}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
